




























import { Component, Vue, Prop, Emit } from 'vue-property-decorator'
import RecorridosResultList from './RecorridosResultList.vue'

@Component({
  components: {
    RecorridosResultList,
  },
})
export default class ABSearchResults extends Vue {
  get hayResultados() {
    return this.recorridos.length > 0
  }
  get recorridos() {
    return this.$store.getters.getRecorridos
  }
  get recorridoSelectedIndex() {
    return this.$store.getters.getRecorridoSelectedIndex
  }
  set recorridoSelectedIndex(val) {
    this.$store.dispatch('setRecorridoSelectedIndex', val)
  }
  get loadingResults() {
    return this.$store.getters.getRecorridosLoading
  }
  public buscarConTransbordo() {
    ;(this as any).$ga.event('resultados', 'buscarTransbordo')
    this.$store.dispatch('setTransbordo', true)
    this.$store.dispatch('query')
  }
  get geolocationError() {
    return this.$store.getters.geolocationError
  }
  get apiError() {
    return this.$store.getters.apiError
  }
  public retry() {
    ;(this as any).$ga.event('resultados', 'retry')
    this.$store.dispatch('query')
  }
}
